import image1 from './images/1.jpg'
import image2 from './images/2.jpg'

const images = { a: image1, b: image2 }

type Props = {
  image: keyof typeof images
  children?: React.ReactNode
}

// セクションの間に挟む幕間の画像
export const VisualBreak: React.FC<Props> = ({ image, children }) => {
  return (
    <section className="relative h-74.5 overflow-hidden flex items-center justify-center">
      <img src={images[image]} alt="" className="absolute inset-0 w-full h-full object-cover" />
      {children && (
        <>
          <div className="absolute inset-0 bg-black/10" />
          <p className="relative text-white text-[18px] font-bold leading-[1.6] text-center">
            {children}
          </p>
        </>
      )}
    </section>
  )
}
